<div class="flex flex-col gap-1 text-base font-semibold text-default">
  <div class="flex justify-between">
    <span [ngClass]="{ 'text-success': isDiscount }">{{ item.description }}</span>
    <span [ngClass]="{ 'text-success': isDiscount }">{{ item.amount | subscriptionCurrency }}</span>
  </div>

  @if (item.note) {
    <div class="text-sm font-medium text-support">
      {{ item.note }}
    </div>
  }

  @if (extraItem) {
    <div class="flex items-center justify-between pl-4">
      <span class="text-sm font-medium text-support">
        {{ extraItem.description }}
      </span>
      <span class="text-sm font-medium text-success">
        {{ extraItem.amount | subscriptionCurrency }}
      </span>
    </div>
  }
</div>
